(() => {
  const roots = document.querySelectorAll('[data-ut-oem]');
  roots.forEach((root) => {
    const items = root.querySelectorAll('.ut-oem__faq-item');
    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        items.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  });
})();
